import { FetchUsersResponse } from "../../../types/apiResponsesTypes";
import { User } from "../../../types/user";
import GenericTable from "../GenericTable";
import useTableUsers from "./hooks/useTableUsers";
import "./TableUsers.scss";

type Props = {
  eventsData: FetchUsersResponse | undefined;
  fetchData: (queryParams?: string) => void;
  isLoading: boolean;
  onModify: (id: number) => void;
  onDelete: (id: number) => void;
  onSearchChangedFromProps: (search: string) => void;
};

const TableEvents: React.FC<Props> = ({
  eventsData,
  fetchData,
  isLoading,
  onModify,
  onDelete,
  onSearchChangedFromProps,
}) => {
  const { columns, onRowClick } = useTableUsers({ onModify, onDelete });

  return (
    <GenericTable<User>
      results={eventsData?.results || []}
      count={eventsData?.count || 0}
      columns={columns}
      fetchData={fetchData}
      isLoading={isLoading}
      onRow={onRowClick}
      onSearchChangedFromProps={onSearchChangedFromProps}
    />
  );
};

export default TableEvents;
